import { SelectElement } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';
import { rudoMessages } from './rudo-messages';

/**
 * Select for Rudo VOD restriction. Uses string ids so MUI Select can display value "0".
 */
export function RudoRestrictionField() {
  const { $t } = useIntl();

  return (
    <SelectElement
      name="restriction"
      label={$t(rudoMessages.restrictionLabel)}
      options={[
        {
          id: '0',
          label: $t(rudoMessages.restrictionNone),
        },
        {
          id: '1',
          label: $t(rudoMessages.restrictionPremium),
        },
        {
          id: '2',
          label: $t(rudoMessages.restrictionRegistration),
        },
      ]}
      fullWidth
    />
  );
}
